export default {
  path: '/travel-documents/machine-operation/:id',
  name: 'MachineOperationDetailsView',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/MachineOperationDetailsView.vue')
}
